export const LIMIT_ATTACH_IMAGES = 5;
//# sourceMappingURL=constants.js.map